export default "/images/vendor/flag-icon-css/flags/4x3/py.svg?b4f1de657b201640e4eccf818b18f4d2";